import { render, staticRenderFns } from "./PregnancyTreatmentModal.vue?vue&type=template&id=6c4d9b1e"
import script from "./PregnancyTreatmentModal.vue?vue&type=script&lang=js"
export * from "./PregnancyTreatmentModal.vue?vue&type=script&lang=js"
import style0 from "./PregnancyTreatmentModal.vue?vue&type=style&index=0&id=6c4d9b1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports